<template>
  <div>
    <el-row :gutter="32">
      <el-col :md="20" :xs="{span: 24, offset: 0}" :offset="2">
        <elsa-section
          :title="$t('dashboard.overview')"
        >
          <template v-slot:body>
            <el-row :gutter="35" type="flex" class="overview-section">
              <el-col :md="12" :xs="24">
                <icon-info-box
                  icon="class-white"
                  :value="numberOfClasses"
                  :label="$t($i18nLabelsHelper(currentOrganizationType, 'groups'))"
                />
              </el-col>
              <el-col :md="12" :xs="24">
                <icon-info-box
                  icon="goals-minutes-day"
                  :value="numberOfMinutesPerDay"
                  :label="$t('classes.classes_details.overview_section.minutes_per_day')"
                  :showListText="$t('classes.classes_details.menu.detailed_progress')"
                  :showListAction="gotToStudentDetails"
                />
              </el-col>
            </el-row>
          </template>
        </elsa-section>
        <elsa-section
          :title="$t('dashboard.your_class')"
        >
          <template v-slot:body>
              <!-- <date-interval-picker
              :startDate="startDate"
              :endDate="endDate"
              @updatedDate="setNewDate"
              :showScope=false
            /> -->
            <div
              v-for="(classObject,idx) in sampleClasses"
              :key="idx"
              class="class-list"
            >
              <div class="class-header">
                <span class="class-name">
                  {{ classObject.name }}
                </span>
                <router-link class="link" :to="{
                  name: 'class-details',
                  params: {
                    organizationId: currentOrganizationId,
                    classId: classObject.id
                    }
                  }"
                >
                  {{ $t('dashboard.student.view_class') }}
                </router-link>
              </div>
              <class-progress :classData="classObject"/>
              <el-row :gutter="35" type="flex" class="class-details">
                <el-col :md="12" :xs="24">
                  <div class="teacher" v-if="classObject.owner">
                    <initial-avatar 
                      v-bind="$attrs" 
                      :avatarUrl="classObject.owner.photo_url" 
                      size="large" 
                      :userObject=classObject.owner 
                    /> 
                    <div class="teacher-profile">
                      <span class="role">
                        {{ $t($i18nLabelsHelper(currentOrganizationType, 'teacher')) }}
                      </span>
                      <span class="full-name">
                        {{ classObject.owner.first_name }}
                        {{ classObject.owner.last_name }}
                      </span>
                      <span class="email">
                        {{ classObject.owner.email }}
                      </span>
                    </div>
                  </div>
                </el-col>
                <el-col :md="12" :xs="24" class="goal days-per-week">
                  <icon-info-box
                    icon="goals-days-practice"
                    :value="$t('dashboard.student.goals.minutes_per_day', {
                      minutes: getMinutesPerDayGoal(classObject)
                    })"
                  />
                </el-col>
                <el-col :md="12" :xs="24" class="goal minutes-per-day">
                  <icon-info-box
                    icon="goals-minutes-day"
                    :value="$t('dashboard.student.goals.days_per_week', {
                      days: getDaysPerWeekGoal(classObject)
                    })"
                  />
                </el-col>
                <!-- <el-col :md="12" :xs="24" class="goal level">
                  <icon-info-box
                    icon="average-score"
                    :value="$t('dashboard.student.goals.level', {
                      days: getLevelLong(classObject)
                    })"
                    :label="$t('dashboard.student.goals.level_value', {
                      days: getLevelValue(classObject),
                    })"
                  />
                </el-col> -->
              </el-row>
            </div>
          </template>
        </elsa-section>

        <!-- <router-link
          v-if="hasClasses"
          class="link all-classes"
          :to="{
            name: 'classes',
            params: {
              organizationId: currentOrganizationId
            }
          }"
        >
          {{ $t('dashboard.student.view_all_classes') }}
        </router-link> -->
      </el-col>
      <!-- <el-col :md="6" :xs="24">
        <elsa-section
          :title="$t('dashboard.notifications')"
        >
        </elsa-section>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
  import ElsaSection from '@/components/common/ElsaSection'
  import IconInfoBox from '@/components/common/IconInfoBox'
  import ClassProgress from '@/components/common/ClassProgress'
  import { startOfMonth, toDate } from 'date-fns'
  import InitialAvatar from '@/components/common/InitialAvatar'
  // import DateIntervalPicker from '@/components/common/DateIntervalPicker'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { compose, slice, pathOr, isEmpty, prop, propOr, not } from 'ramda'
  import {round} from '../../utils/ramda-utils'
  import { warningMessage } from '../../utils/messages'
  import { extractDate } from '@/utils/dateInterval';

  export default {
    components: {
      ElsaSection,
      IconInfoBox,
      // DateIntervalPicker,
      ClassProgress,
      InitialAvatar,
    },
    data() {
      return {
        startDate: startOfMonth(Date.now()),
        endDate: toDate(Date.now())
      }
    },
    computed: {
      numberOfClasses: pathOr(0, ['allClasses', 'count']),
      numberOfMinutesPerDay: compose(round, pathOr(0, ['overviewData', 'lessons_per_day'])),
      classes: pathOr(0, ['allClasses', 'results']),
      hasClasses: compose(not, isEmpty, prop('classes')),
      sampleClasses: compose(
        slice(0,3),
        propOr([], 'classes')
      ),
      ...mapState({
        allClasses: pathOr({}, ['students', 'studentClasses']),
        overviewData: pathOr({}, ['students', 'overviewData']),
      }),
      ...mapGetters({
        userId: "user/getUserId",
        currentOrganizationType: 'organization/currentOrganizationType',
        currentOrganizationId: 'organization/currentOrganizationId',
      }),
    },
    methods: {
      setNewDate(dateObject) {
        this.startDate = dateObject.startDate
        this.endDate = dateObject.endDate
      },
      getMinutesPerDayGoal(classObject) {
        return classObject.assignment.practice_minutes_per_day;
      },
      getMinutesPerDayValue(classObject) {
      },
      getDaysPerWeekGoal(classObject) {
        return classObject.assignment.practice_days_per_week;
      },
      getDaysPerWeekValue(classObject) {

      },
      getLevelLong(classObject) {

      },
      getLevelValue(classObject) {

      },
      gotToStudentDetails() {
        const studentId = this.userId
        const organizationId = this.$store.getters['organization/currentOrganizationId']
        return this.$router.push({
          name: 'student-details',
          params: {
            studentId,
            organizationId,
            }
        })
      },
      ...mapActions({
        getClasses: 'students/getStudentClasses',
        getClass: 'class/getClass',
        getOverviewData: 'students/getOverviewData'
      })
    },
    mounted () {
      try {
        this.getClasses({ studentId: this.userId })
        this.getOverviewData({
          studentId: this.userId,
          from: extractDate(this.startDate),
          to: extractDate(this.endDate),
          scope: this.scope
        })
      } catch (e) {
        return warningMessage(this.$t('common.generic_error_message'))(this)
      }

    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .class-details {
    margin-top: 20px;
    .el-col {
      margin: 20px 0;
    }
  }

  .class-list {
    margin-top: 32px;
    background-color: white;
    padding: 32px;
  }

  .teacher {
    display: flex;
    flex-direction: row;

    .teacher-profile {
      display: flex;
      flex-direction: column;
      margin-left: 16px;

      span {
        font-size: 16px;
        color: $darker-blue;
      }

      .role {
        margin-bottom: 8px;
        text-transform: capitalize;
      }

      .full-name {
        font-weight: 600;
        text-transform: capitalize;

        color: $purple;
      }

      .email {
        font-size: 14px;
        text-transform: lowercase;
        opacity: 0.5;
      }
    }
  }

  .teacher-avatar, ::v-deep .icon-info-box img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }

  .class-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 32px;
  }

  .class-details::v-deep .icon-info-box {
    align-items: center;

    .info {
      .value {
        font-weight: 300;
        font-size: 14px;
        color: $darker-blue;
        opacity: 0.5;
      }

      .label {
        font-weight: bold;
        font-size: 14px;
        text-transform: capitalize;
        color: $darker-blue;
      }
    }
  }

  ::v-deep .elsa-section {
    background-color: transparent;
  }

  a.link {
    font-family: 'SF Pro Display';
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    text-decoration-line: underline;
    text-transform: capitalize;
    color: $purple;

    &.all-classes {
      margin: auto 32px;
    }
  }

  ::v-deep .elsa-section {
    padding: 32px;
  }

  .overview-section {
    .el-col {
      padding-bottom: 20px;
    }
  }
</style>
